var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "yellow lighten-1",
                    dense: "",
                    outlined: "",
                    "hide-details": "auto"
                  }
                },
                [
                  _c("span", [
                    _vm._v("Client: " + _vm._s(_vm.$route.params.customer))
                  ]),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-account")]),
                  _c("v-icon", [_vm._v("mdi-pencil")])
                ],
                1
              ),
              _vm._l(_vm.custPostErrors, function(item, index) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(item.first()))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Customer Category",
                  items: _vm.custCatList,
                  loading: _vm.custCatGetting,
                  "item-value": "id"
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.customerCategoryId,
                  callback: function($$v) {
                    _vm.customerCategoryId = $$v
                  },
                  expression: "customerCategoryId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Company",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.company,
                  callback: function($$v) {
                    _vm.company = $$v
                  },
                  expression: "company"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "TIN",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.tinNumber,
                  callback: function($$v) {
                    _vm.tinNumber = $$v
                  },
                  expression: "tinNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Region",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.region,
                  callback: function($$v) {
                    _vm.region = $$v
                  },
                  expression: "region"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Province",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.province,
                  callback: function($$v) {
                    _vm.province = $$v
                  },
                  expression: "province"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "City",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.city,
                  callback: function($$v) {
                    _vm.city = $$v
                  },
                  expression: "city"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Brgy",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.brgy,
                  callback: function($$v) {
                    _vm.brgy = $$v
                  },
                  expression: "brgy"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Purok",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.purok,
                  callback: function($$v) {
                    _vm.purok = $$v
                  },
                  expression: "purok"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Street",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.street,
                  callback: function($$v) {
                    _vm.street = $$v
                  },
                  expression: "street"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12", "offset-lg": "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "House No",
                  loading: _vm.custGetting
                },
                model: {
                  value: _vm.houseNo,
                  callback: function($$v) {
                    _vm.houseNo = $$v
                  },
                  expression: "houseNo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  label: "Contact No"
                },
                model: {
                  value: _vm.contactNo,
                  callback: function($$v) {
                    _vm.contactNo = $$v
                  },
                  expression: "contactNo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    loading: _vm.custPosting
                  },
                  on: { click: _vm.updateCustomer }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "red", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/customers")
                    }
                  }
                },
                [_c("span", [_vm._v("Cancel")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }